<template>
  <div
    class="offcanvas"
    :class="{ 'offcanvas-end': !isLeft, 'offcanvas-start': isLeft }"
    :style="{ width: (size ? size : 650) + 'px' }"
    ref="el"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">{{ title }}</h5>
      <button class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>
    <div
      class="offcanvas-body overflow-scroll"
      :class="{ 'p-0': noBodyPadding }"
    >
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";

export default {
  name: "EpiOffcanvas",
  props: [
    "openingEventName",
    "closingEventName",
    "title",
    "size",
    "isLeft",
    "noBodyPadding",
  ],
  data() {
    return {
      offcanvas: null,
    };
  },
  methods: {
    openOffcanvas() {
      this.offcanvas.show();
    },
    closeOffcanvas() {
      this.offcanvas.hide();
    },
  },
  mounted() {
    this.offcanvas = new bootstrap.Offcanvas(this.$refs.el);
    this.$root.$on(this.openingEventName, this.openOffcanvas);
    this.$root.$on(this.closingEventName, this.closeOffcanvas);
  },
  beforeDestroy() {
    this.$root.$off(this.openingEventName, this.openOffcanvas);
    this.$root.$off(this.closingEventName, this.closeOffcanvas);
  },
};
</script>
